module.exports = __webpack_public_path__ + "media/images/black_history_month/music-vector-c49ca4787286e6cb95d0406928e1419b.png";